<template>
  <MtxPage width="md">
    <template #header class="faucet__header">
      <h1>Ropsten Matryx Faucet</h1>
    </template>

    <div class="my-4 container-sm">
      <p>
        We're excited to have you as one of our early testers! This faucet will send you
        <strong>ETH</strong>
        and
        <strong>MTX</strong>
        on the
        <strong>Ropsten Test Network.</strong>
      </p>

      <p>
        <strong>Note:</strong>
        The tokens you receive cannot be used for transactions on the main Ethereum network. They
        are just for testing purposes.
      </p>
    </div>

    <div class="grid grid-2-columns grid-gap">
      <MtxCard class="flex flex-column">
        <h3>ETH</h3>
        <p class="flex-grow">
          ETH is used for every Ethereum application in some way or another. On the Matryx platform
          it is required to cover the Gas Price on any transaction.
        </p>

        <div class="text-center">
          <MtxInput
            v-model="isUnderstoodETH"
            type="checkbox"
            label="I understand this is not real ETH"
            class="mb-1"
            required
          />
        </div>

        <button v-if="!web3.ready" @click="requireWeb3()">Sign in to request ETH</button>
        <button v-else-if="ethBalance >= 1" disabled>Already have ETH</button>
        <button v-else @click="requestEth" :disabled="isDisabled">Request 1 ETH</button>
        <small class="faucet__more-info">
          Manually request ETH at
          <a href="https://faucet.ropsten.be/" target="_blank">https://faucet.ropsten.be/</a>
        </small>
      </MtxCard>
      <MtxCard class="flex flex-column">
        <h3>MTX</h3>
        <p class="flex-grow">
          MTX is used for transactions on the Matryx platform. You can use Ropsten ETH to acquire
          Ropsten MTX by using 0x Instant below.
        </p>

        <div class="text-center">
          <MtxInput
            v-model="isUnderstoodMTX"
            type="checkbox"
            label="I understand this is not real MTX"
            class="mb-1"
            required
          />
        </div>

        <ZeroExInstant :disabled="!isUnderstoodMTX" />
        <small class="faucet__more-info">
          For information on getting MTX, you can
          <a href="https://t.me/matryxai" target="_blank">ask the community</a>
        </small>
      </MtxCard>
    </div>

    <div class="text-center mt-3">
      <button @click="showCat = true" class="btn--link"><em>how it works</em></button>
    </div>

    <MtxModal v-model="showCat">
      <iframe
        src="https://giphy.com/embed/CrA66TnJqNFaU"
        width="480"
        height="480"
        frameBorder="0"
      ></iframe>
    </MtxModal>
  </MtxPage>
</template>

<script>
import ZeroExInstant from "@/components/misc/ZeroExInstant"
import web3 from "@/mixins/web3"
import errors from "@/data/errors"

export default {
  mixins: [web3],

  components: {
    ZeroExInstant
  },

  data: () => ({
    isLoading: false,
    isUnderstoodETH: false,
    isUnderstoodMTX: false,
    showCat: false,
    ethBalance: 0
  }),

  metaInfo: {
    titleTemplate: "%s | Faucet",
    meta: [{ name: "description", content: "Get ETH and MTX for the Ropsten Test Network" }]
  },

  computed: {
    isDisabled() {
      return !this.isUnderstoodETH || this.isLoading || !this.web3.account
    }
  },

  watch: {
    "$store.state.user.ethAddress": {
      handler: "prepareWeb3",
      immediate: true
    }
  },

  methods: {
    async prepareWeb3() {
      if (!this.web3.account) return

      try {
        this.isLoading = true

        // Get ETH balance
        window.web3.eth.getBalance(this.web3.account, (err, res) => {
          if (err) return

          this.ethBalance = +window.web3.fromWei(res)
        })
      } catch (error) {
        this.$notify({
          title: "Error",
          type: "error",
          text: errors.API_UNKNOWN
        })
      } finally {
        this.isLoading = false
      }
    },

    async requestEth() {
      if (!this.web3.account) return

      try {
        this.isLoading = true
        const res = await fetch(`https://faucet.ropsten.be/donate/${this.web3.account}`)

        if (res.ok) {
          this.$notify({
            type: "success",
            text: "ETH requested"
          })
        } else {
          this.$notify({
            type: "error",
            text: "ETH already requested"
          })
        }
      } catch (error) {
        this.$notify({
          title: "Error",
          type: "error",
          text: errors.API_UNKNOWN
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
